// FINAL Horizon-safe Call-for-Price blocker (handle-correct + mutation-proof)
document.addEventListener("DOMContentLoaded", () => {
  const HANDLE = "e-biotic-pro-the-definitive-commercial-whole-home-system";

  // Only run on this exact product
  if (!window.location.pathname.includes(`/products/${HANDLE}`)) return;

  const removePurchaseUI = () => {
    // Remove Add to Cart forms
    document.querySelectorAll('form[action*="/cart/add"]').forEach(el => el.remove());

    // Remove Shopify / Shop Pay / dynamic checkout
    document.querySelectorAll(
      'iframe, [class*="payment"], [class*="shop"], button'
    ).forEach(el => {
      const text = (el.innerText || "").toLowerCase();
      if (
        text.includes("buy") ||
        text.includes("shop") ||
        text.includes("pay")
      ) {
        el.remove();
      }
    });
  };

  // Run immediately
  removePurchaseUI();

  // Run again when Horizon re-renders (this is the key)
  const observer = new MutationObserver(removePurchaseUI);
  observer.observe(document.body, { childList: true, subtree: true });
});